import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const WebDevelopmentJobsGurugram = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Web Development Jobs in Gurugram | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Explore the latest Web Development Jobs in Gurugram NCR. Find openings for Frontend, Backend, and Full Stack Web Developers. Apply now at JobsInDelhiNCR."
        />
        <meta
          name="keywords"
          content="web development jobs in Gurugram, frontend developer jobs Gurugram, backend developer jobs Gurugram, full stack web developer jobs Delhi, HTML CSS JavaScript jobs Delhi, React developer jobs Delhi, Node.js developer jobs Delhi, web designer jobs Delhi NCR, fresher web developer jobs Delhi, web developer openings Gurugram"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/webdevelopment-jobs-in-gurugram"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Web Development Jobs in Gurugram – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>Web Development Jobs in Gurugram NCR</strong>? Whether you're a frontend, backend, or full stack web developer, explore verified opportunities across top companies and startups hiring in Gurugram.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Web Developers in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Accenture</li>
          <li>Wipro</li>
          <li>Infosys</li>
          <li>HCL</li>
          <li>Tech Mahindra</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Web Developer Roles in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Frontend Developer Jobs in Gurugram</li>
          <li>Backend Developer Jobs in Gurugram</li>
          <li>Full Stack Developer Jobs in Gurugram</li>
          <li>React Developer Jobs in Gurugram</li>
          <li>Node.js Developer Jobs in Gurugram</li>
          <li>PHP Developer Jobs in Gurugram</li>
          <li>JavaScript Developer Jobs in Gurugram</li>
          <li>Web Designer Jobs in Gurugram</li>
          <li>HTML/CSS Developer Jobs in Gurugram</li>
          <li>WordPress Developer Jobs in Gurugram</li>
        </ul>

        <p className="text-gray-600">
          Kickstart your career with <strong>jobsindelhincr.in</strong> — your trusted job portal to find verified <strong>Web Development Jobs in Gurugram</strong>. No registration required – apply directly and start working with the best companies today.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default WebDevelopmentJobsGurugram;
